import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Leistungen from "../pages/leistungen/page";
import Referenzen from "../pages/referenzen/page";
import UeberUns from "../pages/ueber-uns/page";
import Karriere from "../pages/karriere/page";
import Kontakt from "../pages/kontakt/page";
import Impressum from "../pages/impressum/page";
import Datenschutz from "../pages/datenschutz/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/leistungen",
    element: <Leistungen />,
  },
  {
    path: "/referenzen",
    element: <Referenzen />,
  },
  {
    path: "/ueber-uns",
    element: <UeberUns />,
  },
  {
    path: "/karriere",
    element: <Karriere />,
  },
  {
    path: "/kontakt",
    element: <Kontakt />,
  },
  {
    path: "/impressum",
    element: <Impressum />,
  },
  {
    path: "/datenschutz",
    element: <Datenschutz />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;